module.exports = __webpack_public_path__ + "img/rf-logo.94eadfa9.png";